<template>
  <div ref="container" class="text-black">
    <q-carousel
      ref="carousel"
      animated
      v-model="slide"
      :height="`${scrollerHeight}px`"
      control-type="outline"
      infinite
    >
      <q-carousel-slide
        v-for="(item, i) in sectionData.slides"
        :key="i"
        :name="i"
        :img-src="imageUrl"
      />
    </q-carousel>
    <div
      :style="`height:${scrollerHeight}px`"
      class="virtualtour-overlay q-py-md column items-center content-center justify-between"
    >
      <div style="height: 25%; font-size: 1.05em" class="text-white">
        EXPLORE 360&deg; TOUR
      </div>
      <div style="height: 50%" class="column justify-center">
        <q-btn
          @click="invokeComponent"
          style="background: rgba(0, 0, 0, 0.7); color: #ddd"
          round
          size="lg"
          icon="play_arrow"
        />
      </div>

      <div
        :class="`column justify-end full-width q-px-md text-${textAlign} text-white`"
        style="height: 25%"
      >
        <div>
          <div class="overline" v-if="overline">
            <div class="non-selectable text-uppercase">
              {{ overline }}
            </div>
          </div>
          <div class="title" v-if="title">
            <div class="non-selectable">
              {{ title }}
            </div>
          </div>
          <div class="caption" v-if="caption">
            <div class="non-selectable">
              {{ caption }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from "../../d-card-mixins";
import getImgUrl from "../../mixins/get-img-url";

export default {
  name: "DVirtualTour",
  mixins: [mixin, getImgUrl],
  props: {
    sectionData: {
      type: Object,
      default: () => {},
    },
    storePath: {
      type: String,
      required: true,
    },
    behavior: {
      type: String,
      default: "agent",
    },
    scrollerHeight: {
      type: Number,
      required: true,
    },
    mediaManagerRequestUrl: {
      type: String,
      required: false,
      default: "",
    },
  },
  data() {
    return {
      lslide: 0,
      imageUrl: null,
    };
  },
  computed: {
    slide: {
      get() {
        if (this.behavior === "agent") {
          return this.lslide;
        } else {
          let data = JSON.parse(this.$cardStore.get(this.storePath));
          if (data.slide === undefined) {
            data.slide = 0;
          }
          return data.slide;
        }
      },
      set(val) {
        if (this.behavior === "agent") {
          this.lslide = val;
        } else {
          this.$cardStore.set(this.storePath, JSON.stringify({ slide: val }));
        }
      },
    },
    overline: {
      get() {
        return this.sectionData.overline;
      },
    },
    title: {
      get() {
        return this.sectionData.title;
      },
    },
    caption: {
      get() {
        return this.sectionData.caption;
      },
    },
    textAlign: {
      get() {
        return this.sectionData.textAlign ?? "center";
      },
    },
  },
  mounted() {
    this.setImage(0);
  },
  methods: {
    invokeComponent() {
      this.$emit("invokeComponent", {
        component: "DVirtualTourComponent",
        id: this.sectionData.id,
        state: {
          slide: 0,
        },
      });
    },
    async setImage(index) {
      const item = this.sectionData.slides[index];

      this.imageUrl = await this.getImgUrl({
        ...item,
        url: `${this.sectionData.baseUrl}${item.src}`,
        mediaManagerRequestUrl: this.mediaManagerRequestUrl,
      });
    },
  },
};
</script>
<style scoped>
.virtualtour-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  background: rgba(0, 0, 0, 0.3);
}

.overline {
  font-size: 9px;
  font-weight: 800;
  line-height: 16px;
  letter-spacing: 0.2px;
  opacity: 0.8;
}
.title {
  font-size: 14px;
  font-weight: 700;
  line-height: 18px;
  letter-spacing: -0.02px;
}

.caption {
  font-size: 14px;
  line-height: 18px;
  letter-spacing: -0.02px;
}
</style>
